module.exports = __webpack_public_path__ + "img/MRC_IEU Bristol_RGB.3b5efad8.svg";